import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../../assets/icons/Back.svg";
import "../../../css/DesignSystem/Breadcrumb/Breadcrumb.css";

const Breadcrumb = ({ items = [], showBackButton = false, onBack }) => {
  const navigate = useNavigate();
  if (!items.length) return null;

  return (
    <nav className="Breadcrumb" aria-label="Breadcrumb">
      {showBackButton && <button type="button" className="Breadcrumb__BackButton" onClick={onBack || (() => navigate(-1))} aria-label="Go back" title="Go back"><BackIcon aria-hidden /></button>}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {item.to && !isLast ? (
              <Link className="Breadcrumb__Item FP_Help_Text" to={item.to}>
                {item.label}
              </Link>
            ) : (
              <span
                className={`FP_Help_Text ${
                  isLast ? "FP_Help_Text_Semibold primary" : ""
                }`}
              >
                {item.label}
              </span>
            )}

            {!isLast && <span className="Breadcrumb__Separator">&gt;</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
